import moment from 'moment'

import {
  BooleanQuestion,
  DateQuestion,
  DropdownQuestion,
  PhotoQuestion,
  Question,
  Questions,
} from '../../classes/question'
import { InsuranceRelationship } from '../../data'

export interface Insurance {
  insuranceCarrier: string
  insuranceNumber: string
  key: string
}

export const getInsuranceQuestions = (
  customQuestions: Questions,
): Questions => {
  let defaultQuestion: Questions

  defaultQuestion = [
    new BooleanQuestion({
      label: 'patient-intake.insurance-section.field-insurance-question',
      key: 'hasInsurance',
      required: true,
      ifQuestions: getQuestions(customQuestions),
      ifNoProceed: true,
    }),
  ]

  return defaultQuestion
}

const getQuestions = (customQuestions: Questions): Questions => [
  new PhotoQuestion({
    label: 'patient-intake.insurance-section.field-photo-front',
    key: 'insuranceCard',
    flex: '50',
    insurance: true,
  }),

  new PhotoQuestion({
    label: 'patient-intake.insurance-section.field-photo-back',
    key: 'insuranceCardBack',
    flex: '50',
    insurance: true,
  }),

  // new InsuranceCarrierSelectorQuestion({
  //   label: 'patient-intake.insurance-section.field-insurance-provider',
  //   key: 'insuranceCarrier',
  //   hint: 'patient-intake.insurance-section.field-insurance-provider-hint',
  //   flex: '100',
  //   required: true,
  // }),

  new Question({
    label: 'patient-intake.insurance-section.field-insurance-provider-number',
    key: 'insuranceNumber',
    hint: 'patient-intake.insurance-section.field-insurance-provider-number-hint',
    flex: '100',
    required: true,
    options: { allowUnknownInsurance: true },
  }),

  new BooleanQuestion({
    label: 'patient-intake.insurance-section.field-insurance-primary-question',
    key: 'isPrimaryOnInsurance',
    required: true,
    if: false,
    ifQuestions: getInsuranceHolderQuestions(),
  }),

  ...customQuestions,
]

const getInsuranceHolderQuestions = (): Questions => [
  new Question({
    label: 'patient-intake.insurance-section.field-insurance-holder-first-name',
    key: 'insuranceHolderFirstName',
    required: true,
    flex: '50',
  }),

  new Question({
    label: 'patient-intake.insurance-section.field-insurance-holder-last-name',
    key: 'insuranceHolderLastName',
    required: true,
    flex: '50',
  }),

  new DropdownQuestion({
    label:
      'patient-intake.insurance-section.field-insurance-holder-relationship',
    hint: 'patient-intake.insurance-section.field-insurance-holder-relationship-hint',
    key: 'insuranceRelationship',
    options: InsuranceRelationship,
    required: true,
    flex: '50',
  }),

  new DateQuestion({
    label: 'patient-intake.insurance-section.field-insurance-holder-dob',
    key: 'insuranceHolderDob',
    required: true,
    flex: '50',
    max: moment().format('YYYY-MM-DD'),
  }),
]
